export function hexToRgb(
  hex: string
): { r: number; g: number; b: number } | null {
  // Hub settings may contain dirty values like ' #231D20' (leading space),
  // which used to reach jsPDF as NaN and throw "Invalid argument passed to jsPDF.f2"
  if (!hex) {
    return null;
  }

  hex = hex.trim();
  hex = hex.startsWith('#') ? hex.slice(1) : hex;

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (hex.length !== 6) {
    return null;
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return null;
  }

  return { r, g, b };
}
